import { forwardRef, HTMLAttributes } from "react";
import { motion } from "framer-motion";

import { styled } from "~/application/theme";
import { Icon } from "../../Icon";

const ButtonContainer = styled("button", {
  all: "unset",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "64px",
  height: "64px",
  position: "relative",
});

const ActiveSlider = styled(motion.div, {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  background: "$primary-base",
  borderRadius: "9999px",
  padding: "10px 12px",
  gap: "6px",
  color: "$neutrals-white",
  fontWeight: 600,
  fontSize: "$xs",
  zIndex: 0,
  position: "absolute",
});

interface TabItemProps extends HTMLAttributes<HTMLButtonElement> {
  icon: any;
  label: string;
  isActive: boolean;
  onClick?: () => void;
}

export const TabItem = forwardRef<HTMLButtonElement, TabItemProps>(
  ({ icon, label, isActive, onClick, ...props }, ref) => {
    return (
      <ButtonContainer ref={ref} onClick={onClick} {...props}>
        {isActive ? (
          <ActiveSlider
            layoutId="tab-indicator"
            transition={{ type: "spring", bounce: 0.3, duration: 0.4 }}
          >
            <Icon as={icon} variant="white" size="md" />
            <span>{label}</span>
          </ActiveSlider>
        ) : (
          <Icon as={icon} variant="neutral-400" size="md" />
        )}
      </ButtonContainer>
    );
  },
);
